const SessionID = "yKDc76sxU3xkOeo3VOq6abegV5A6zcKI";
const cafe = {
    media: {
        image: [".ico", ".jpg", ".jpeg", ".png", ".gif", ".svg"],
        script: [".js", ".ts", ".map"],
        doc: [".txt", ".pdf", ".docx", ".xlsx", ".xml", ".html", ".htm"],
        audio: [".mp3"],
        video: [".mp4", ".flv"],
        font: [".ttf", ".otf", ".woff", ".woff2"],
    },
    cus: ["sa", "VIP", "customer"],
};
const cfm = cafe.media;
const publicPage = [
    "/",
    "/authen/login",
    "/authen/register",
    "/authen/activate",
    "/authen/password/forgot",
    "/tool/stock/scan",
];
const pageRole = [
    { href: "/authen/logout", isDetail: false, roles: ["customer"] },
    { href: "/project/list", isDetail: false, roles: ["customer"] },
    { href: "/project/detail", isDetail: true, roles: ["customer"] },
    { href: "/link/ranking", isDetail: true, roles: ["customer"] },
    { href: "/tool/file/metadata", isDetail: false, roles: ["customer"] },
    { href: "/tool/qrcode/create", isDetail: false, roles: ["customer"] },
];

module.exports = {
    SessionID,
    publicPage,
    pageRole,
    transpileDependencies: ["vuetify"],
    file: {
        media: {
            extension: [...cfm.image, ...cfm.script, ...cfm.doc, ...cfm.audio, ...cfm.video, ...cfm.font],
            doc: cfm.doc,
        },
    },
};



// WEBPACK FOOTER //
// vue.config.js